<template lang="pug">
#safety-confirm-register-input
  // title
  .d-flex.flex-row.justify-content-center.mb-3
    .page-title 安否確認の新規作成

  // progress
  ProcessIndicator(v-model="indicator")
  .mb-3.separator

  // discription
  .mb-3
    .discription 安否確認の実施時にタイトルを新規作成してください。

  // safety confirm content
  .mb-1
    span.key-name タイトル
  // title
  .mb-3
    .d-flex.flex-row.align-items-top
      .flex-grow-1.mr-2
        b-form-input#title(v-model="name" name="name" placeholder="タイトル" maxlength="32" @focus="hideFooter" @blur="showFooter"
          v-validate="{ required: true, max: 32 }" aria-describedby="name" data-vv-as="タイトル")
      .required
        RequireInput
    .error-messages.mt-1(v-if="errors.has('name')")
      label.error-message(v-for="error in errors.collect('name')") {{ error }}

  // buttons
  .mb-3
    ValidationAlert(v-model="showValidationAlert")
  .d-flex.flex-row.justify-content-center
    b-button.btn(@click="gotoConfirm") 確認画面へ

  // loading modal
  Loading(:isBusy="isBusy" :message="loadingMessage")
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { mobileSafetyConfirmRegisterStore } from "@/store/store";
import { MobileSafetyConfirmRegisterState } from "@/store/MobileSafetyConfirmRegister";
import { MobileUrl } from "@/commons/constants/MobileUrl";

import Loading from "@/mobile/basics/Loading.vue";
import ValidationAlert from "@/mobile/basics/ValidationAlertByValidator.vue";
import ProcessIndicator, { ProcessIndicatorModel } from "@/mobile/basics/ProcessIndicator.vue";
import RequireInput from "@/mobile/basics/RequireInput.vue";

/**
 * ### 安否確認 登録情報 入力コンポーネント
 */
@Component({
  components: {
    Loading,
    ValidationAlert,
    ProcessIndicator,
    RequireInput
  },
  $_veeValidate: { validator: "new" }
})
export default class SafetyConfirmRegisterInput extends Vue {
  /** ### 新規送信入力画面での入力情報 */
  @Getter("mobileSafetyConfirmRegisterState") state!: MobileSafetyConfirmRegisterState;

  /** インジケータ */
  indicator: Array<ProcessIndicatorModel> = [
    { text: "入力", current: true },
    { text: "確認", current: false },
    { text: "完了", current: false }
  ];

  /** 読み込み中モーダル表示可否 */
  isBusy: boolean = false;
  /** 読み込み中モーダルメッセージ */
  loadingMessage: string = "読込み中";

  /** バリデーションアラート表示可否 */
  showValidationAlert: boolean = false;

  /** 安否確認名 */
  name: string = "";

  /**
   * ### vue lifecycle mounted
   */
  public async mounted(): Promise<void> {
    this.createView();
    return;
  }

  /**
   * ### 画面表示情報を作成する
   */
  public createView(): void {
    this.name = "";

    this.restoreInputValues();

    return;
  }

  /**
   * ### 入力情報の復元
   *
   * - storeに入力情報が保持されていれば復元する
   * - 復元後はstoreの内容をリセットする
   */
  public restoreInputValues(): void {
    if (this.state.exist == true) {
      this.name = this.state.name;
      mobileSafetyConfirmRegisterStore.resetMobileSafetyConfirmRegisterState();
    }

    return;
  }

  /**
   * ### 新規送信のプレビュー画面へ遷移する
   *
   * - バリデーションチェック
   * - バリデーションチェックでエラーが無ければ以下を実施
   *   - ストアに入力情報を格納
   *   - 確認画面へ遷移する
   */
  public async gotoConfirm(): Promise<void> {
    const validationResult: boolean = await this.$validator.validateAll();

    if (validationResult == true) {
      this.showValidationAlert = false;
      this.isBusy = true;

      const state: MobileSafetyConfirmRegisterState = {
        name: this.name,
        exist: true
      };
      mobileSafetyConfirmRegisterStore.updateMobileSafetyConfirmRegisterState({ state: state });

      this.isBusy = false;

      this.$router.push(MobileUrl.SafetyConfirmRegisterConfirm);
    } else {
      this.showValidationAlert = true;
    }

    return;
  }

  /**
   * ### フッターを表示する
   */
  public showFooter(): void {
    this.$emit("updateShowFooter", true);
    return;
  }

  /**
   * ### フッターを非表示にする
   */
  public hideFooter(): void {
    this.$emit("updateShowFooter", false);
    return;
  }
}
</script>
